import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { BookingDiaryComponent } from './booking-diary.component';

export const BookingDiaryStates : Array<NgHybridStateDeclaration> = [
  {
    component: BookingDiaryComponent,
    name     : 'app.booking-diary',
    params   : {
      date: { dynamic: true },
      view: { dynamic: true }
    },
    resolve  : [
      {
        deps     : [ Transition ],
        resolveFn: ( transition : Transition ) : string => transition.params().date,
        token    : 'initialDate'
      },
      {
        deps     : [ Transition ],
        resolveFn: ( transition : Transition ) : string => transition.params().view,
        token    : 'initialView'
      }
    ],
    url: '/booking-diary?date&view'
  }
];
